import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetInvolvedEmployeesQuery } from './get-involved-employees.query';
import { GetInvolvedEmployeesResult } from './get-involved-employees.result';

/**
 * Get involved employees use case.
 * Retrieves employees involved in a case.
 */
@Injectable({ providedIn: 'root' })
export class GetInvolvedEmployeesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetInvolvedEmployeesQuery): Observable<GetInvolvedEmployeesResult> {
    this._state.setLoadingInvolvedEmployees(true);
    this._state.setErrorInvolvedEmployees(null);

    return this._repository.getInvolvedEmployees(query.caseId).pipe(
      tap((employees) => {
        this._state.setInvolvedEmployees(employees);
        this._state.setLoadingInvolvedEmployees(false);
      }),
      map((employees) => ({ employees })),
      catchError((error) => {
        this._state.setErrorInvolvedEmployees(error.message || 'Failed to get involved employees');
        this._state.setLoadingInvolvedEmployees(false);
        return throwError(() => error);
      })
    );
  }
}
